"use client";

import { useEffect, useState } from "react";
import Script from "next/script";
import { parseConsent } from "@/components/site/cookie-consent/utils";
import { CONSENT_UPDATED_EVENT } from "@/components/ui/cookie-consent-events";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
const GTM_ENABLED = process.env.NODE_ENV === "production" && !!GTM_ID;

function consentAllowsGtm(): boolean {
  const { consented, prefs } = parseConsent();
  return consented && (prefs.analytics || prefs.performance || prefs.advertisement);
}

// Loads GTM once consent allows it. Covers every region through the same
// path: opt-in geos grant via CookieYes's banner (consent_update event ->
// ConsentSync -> CONSENT_UPDATED_EVENT), non-targeted geos get an
// implied-grant cookie at SDK boot (picked up by ConsentSync's boot poll),
// and repeat visitors pass the mount-time check directly from the cookie.
export default function GtmLoader() {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (load) return;
    const check = () => {
      if (consentAllowsGtm()) setLoad(true);
    };
    check();
    window.addEventListener(CONSENT_UPDATED_EVENT, check);
    return () => window.removeEventListener(CONSENT_UPDATED_EVENT, check);
  }, [load]);

  if (!load || !GTM_ENABLED) return null;

  return (
    <Script
      id="gtm"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`,
      }}
    />
  );
}
